import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta';
import MainPage from './../views/MainPage'
import ComparePage from '@/views/ComparePage';
import OnboardingPage from '@/views/OnboardingPage';
import LoginPage from '@/views/LoginPage';
import CheckoutSuccessPage from '@/views/CheckoutSuccessPage';
import DashboardPage from '@/views/DashboardPage';

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
    {
        path: '/compare/:id',
        name: 'Compare',
        component: ComparePage,
        // meta: {
        //     title: 'Compare Prices - LensAdvisors',
        //     metaTags: [
        //         {
        //             name: 'description',
        //             content: 'Compare prices among the leading contact lens suppliers'
        //         }
        //     ]
        // }
    },
    {
        path: '/checkout/success/:id',
        name: 'CheckoutSuccess',
        component: CheckoutSuccessPage,
        // meta: {
        //     title: 'Checkout Success - LensAdvisors',
        //     metaTags: [
        //         {
        //             name: 'description',
        //             content: 'Claim your ad space and start driving traffic that matters to your business today'
        //         }
        //     ]
        // }
    },
    {
        path: '/business/dashboard',
        name: 'Dashboard',
        component: DashboardPage,
        // meta: {
        //     title: 'Dashboard - LensAdvisors',
        //     metaTags: [
        //         {
        //             name: 'description',
        //             content: 'Explore all your LensAdvisors ad spots'
        //         }
        //     ]
        // }
    },
    {
        path: '/business/onboarding',
        name: 'Onboarding',
        component: OnboardingPage,
        // meta: {
        //     title: 'Onboarding - LensAdvisors',
        //     metaTags: [
        //         {
        //             name: 'description',
        //             content: 'Claim your ad space and start driving traffic that matters to your business today'
        //         }
        //     ]
        // }
    },
    {
        path: '/business/login',
        name: 'Login',
        component: LoginPage,
        // meta: {
        //     title: 'Welcome back - LensAdvisors',
        //     metaTags: [
        //         {
        //             name: 'description',
        //             content: 'Claim your ad space and start driving traffic that matters to your business today'
        //         }
        //     ]
        // }
    },
    {
        path: '/',
        name: 'Home',
        component: MainPage
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

// // This callback runs before every route change, including on page load.
// router.beforeEach((to, from, next) => {
//     // This goes through the matched routes from last to first, finding the closest route with a title.
//     // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
//     const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

//     // Find the nearest route element with meta tags.
//     const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

//     // If a route with a title was found, set the document (page) title to that value.
//     if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

//     // Remove any stale meta tags from the document using the key attribute we set below.
//     Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

//     // Skip rendering meta tags if there are none.
//     if (!nearestWithMeta) return next();

//     // Turn the meta tag definitions into actual elements in the head.
//     nearestWithMeta.meta.metaTags.map(tagDef => {
//         const tag = document.createElement('meta');

//         Object.keys(tagDef).forEach(key => {
//             tag.setAttribute(key, tagDef[key]);
//         });

//         // We use this to track which meta tags we create, so we don't interfere with other ones.
//         tag.setAttribute('data-vue-router-controlled', '');

//         return tag;
//     })
//         // Add the meta tags to the document head.
//         .forEach(tag => document.head.appendChild(tag));

//     next();
// });

export default router
